export const suppressEmployerOnboardingBankInfo = true;
export const suppressInviteEmailLink = true;
export const validateEmployeeEmailLength = false;
export const disableEmployeeEdit = false;
export const employerCustodianInfoTemplate = "";
export const displayBankAccountHolds = false;